

















































































import Vue from 'vue'
import GHeader from '@/components/globals/GHeader/GHeader.vue'
import Sidebar from '@/components/globals/Sidebar.vue'
import Breadcrumbs from './Breadcrumbs.vue'
import GFooter from '@/components/globals/GFooter.vue'

export default Vue.extend({
  components: {
    GHeader,
    Sidebar,
    Breadcrumbs,
    GFooter,
  },
  props: {
    title: {
      type: String as () => string,
      default: '',
    },
    isTitleCentered: {
      type: Boolean,
      default: false,
    },
    isStickyHeader: {
      type: Boolean,
      default: true,
    },
    hideSpSearch: {
      type: Boolean,
      default: false,
    },
    hidePcSidebar: {
      type: Boolean,
      default: true,
    },
    hideBreadcrumbs: {
      type: Boolean,
      default: false,
    },
    hideBackButton: {
      type: Boolean,
      default: false,
    },
    showSpTitle: {
      type: Boolean,
      default: false,
    },
    hideSpTitle: {
      type: Boolean,
      default: false,
    },
    hidePcTitle: {
      type: Boolean,
      default: false,
    },
    padded: {
      type: Boolean,
      default: true,
    },
    pcGrayBackground: {
      type: Boolean,
      default: false,
    },
    showFooter: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showSidebar: false,
  }),
  computed: {
    hasRightButton(): boolean {
      return Boolean(this.$slots.rightButton)
    },
  },
  methods: {
    onShowSidebar() {
      this.showSidebar = true
    },
    onCloseSidebar() {
      this.showSidebar = false
    },
  },
})
